/*****************************
 * SVG library combination of jquery.svg + jquery.svgdom
 * $.svg.isSVGElem -> isSVGElem
 * Support List
 * addClass, removeClass, hasClass, toggleClass, attr, removeAttr
 *****************************/

(function () {
  'use strict';

  // TODO use NS.SVG instead
  const proxied = jQuery.fn.attr;
  const svgns = 'http://www.w3.org/2000/svg';

  const rclass = /[\t\r\n]/g;
  const rspace = /\s+/;
  const rwhitespace = '[\\x20\\t\\r\\n\\f]';

  /** Retrieve the element classes.
    @private
    @param elem {Element} The element to examine.
    @return {string} The class names. */
  function getClassNames (elem) {
    return (!isSVGElem(elem)
      ? elem.className
      : (elem.className ? elem.className.baseVal : elem.getAttribute('class'))) || '';
  }

  function isSVGElem (node) {
    return (node && node.nodeType === 1 && node.namespaceURI === svgns);
  }

  /** Set the element classes.
    @private
    @param elem {Element} The element to update.
    @param classes {string} The new class names. */
  function setClassNames (elem, classes) {
    (elem.className ? elem.className.baseVal = classes : elem.setAttribute('class', classes));
  }
  /** Support removing class names from SVG nodes.
    @param classNames {string} The classes to remove. */

  /*
  $.fn.remove = function(origRemove) {
    return function(classNames) {
      var origArgs = arguments;
      return this.each(function() {
        if (isSVGElem(this)) {
          var node = this;
          var p = this.parentNode;

          p.removeChild(node);
        }
        else {
          origRemove.apply($(this), origArgs);
        }
      });
    };
  }($.fn.remove);
  */

  /** Support adding class names to SVG nodes.
    @param classNames {string} The classes to add. */
  $.fn.addClass = (function (origAddClass) {
    return function (classNames) {
      if ($.isFunction(classNames)) {
        return this.each(function (i) {
          $(this).addClass(classNames.call(this, i, getClassNames(this)));
        });
      }
      const origArgs = arguments;
      classNames = classNames || '';
      return this.each(function () {
        if (isSVGElem(this)) {
          const node = this;
          $.each(classNames.split(/\s+/), function (i, className) {
            let classes = getClassNames(node);
            if ($.inArray(className, classes.split(/\s+/)) === -1) {
              setClassNames(node, classes += (classes ? ' ' : '') + className);
            }
          });
        } else {
          origAddClass.apply($(this), origArgs);
        }
      });
    };
  }($.fn.addClass));

  /** Support removing class names from SVG nodes.
    @param classNames {string} The classes to remove. */
  $.fn.removeClass = (function (origRemoveClass) {
    return function (classNames) {
      if ($.isFunction(classNames)) {
        return this.each(function (i) {
          $(this).removeClass(classNames.call(this, i, getClassNames(this)));
        });
      }
      const origArgs = arguments;
      classNames = classNames || '';
      return this.each(function () {
        if (isSVGElem(this)) {
          const node = this;
          $.each(classNames.split(/\s+/), function (i, className) {
            let classes = getClassNames(node);
            classes = $.grep(classes.split(/\s+/), function (n, i) { return n !== className; }).join(' ');
            setClassNames(node, classes);
          });
        } else {
          origRemoveClass.apply($(this), origArgs);
        }
      });
    };
  }($.fn.removeClass));

  /** Support toggling class names on SVG nodes.
    @param classNames {string} The classes to toggle. */
  $.fn.toggleClass = (function (origToggleClass) {
    return function (classNames, state) {
      if ($.isFunction(classNames)) {
        return this.each(function (i) {
          $(this).toggleClass(classNames.call(this, i, getClassNames(this), state), state);
        });
      }
      const origArgs = arguments;
      const hasState = (typeof state === 'boolean');
      return this.each(function () {
        if (isSVGElem(this)) {
          if (typeof classNames === 'string') {
            const node = $(this);
            $.each(classNames.split(/\s+/), function (i, className) {
              if (!hasState) {
                state = !node.hasClass(className);
              }
              node[(state ? 'add' : 'remove') + 'Class'](className);
            });
          } else {
            const classes = getClassNames(this);
            if (classes) {
              $._data(this, '__className__', classes); // store className if set
            }
            // toggle whole className
            setClassNames(this, classes || classNames === false ? '' : $._data(this, '__className__') || '');
          }
        } else {
          origToggleClass.apply($(this), origArgs);
        }
      });
    };
  }($.fn.toggleClass));

  /** Support checking class names on SVG nodes.
    @param className {string} The class to check.
    @return {boolean} <code>true</code> if this class is present, <code>false</code> if not. */
  $.fn.hasClass = (function (origHasClass) {
    return function (className) {
      className = className || '';
      let found = false;
      this.each(function () {
        if (isSVGElem(this)) {
          found = ($.inArray(className, getClassNames(this).split(/\s+/)) > -1);
        } else {
          found = (origHasClass.apply($(this), [className]));
        }
        return !found;
      });
      return found;
    };
  }($.fn.hasClass));

  /* Remove */
  $.fn.remove = (function (origRemove) {
    return function () {
      const origArgs = arguments;

      return this.each(function () {
        if (isSVGElem(this)) {
          this.parentNode.removeChild(this);
        } else {
          origRemove.apply($(this), origArgs);
        }
      });
    };
  }($.fn.remove));

  /* Attr */
  $.fn.attr = function (key, value) {
    let i, attr;
    const len = this.length;
    if (!len) { return proxied.apply(this, arguments); }
    for (i = 0; i < len; ++i) {
      const elem = this[i];
      // set/get SVG attribute
      if (elem.namespaceURI === svgns) {
      // Setting attribute
        if (value !== undefined) {
          elem.setAttribute(key, value);
        } else if ($.isArray(key)) {
          // Getting attributes from array
          let j = key.length; const obj = {};

          while (j--) {
            const aname = key[j];
            attr = elem.getAttribute(aname);
            // This returns a number when appropriate
            if (attr || attr === '0') {
              attr = isNaN(attr) ? attr : (attr - 0);
            }
            obj[aname] = attr;
          }
          return obj;
        } else if (typeof key === 'object') {
          // Setting attributes form object
          var v;
          for (v in key) {
            elem.setAttribute(v, key[v]);
          }
        // Getting attribute
        } else {
          attr = elem.getAttribute(key);
          if (attr || attr === '0') {
            attr = isNaN(attr) ? attr : (attr - 0);
          }
          return attr;
        }
      } else {
        return proxied.apply(this, arguments);
        //        proxied.apply(this, arguments);
      }
    }
    return this;
  };
  /** Support removing attributes on SVG nodes.
  @param names {string} The names of the attributes to remove. */
  $.fn.removeAttr = (function (origRemoveAttr) {
    return function (names) {
      const origArgs = arguments;
      return this.each(function () {
        if (isSVGElem(this)) {
          const node = this;
          $.each(names.split(/\s+/), function (i, name) {
            (node[name] && node[name].baseVal ? node[name].baseVal.value = null : node.removeAttribute(name));
          });
        } else {
          origRemoveAttr.apply($(this), origArgs);
        }
      });
    };
  }($.fn.removeAttr));
}());
